<template>
  <label class="flex flex-col">
    <span v-if="label" class="text-sm font-medium text-gray-80">
      {{ label }}
    </span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'AppLabel',

  props: {
    label: String
  }
}
</script>
